import { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import GRSConference from "../routes/grs-routes";
import Footer from "../components/footer/footer";
import SvgIcons from "../components/re-usable/icons/svg-icons";
import { useAppDispatch } from "../redux/store";
import { retrieveNotification } from "../redux/slice/notification-slice";
import LoadingComp from "../components/re-usable/loading/loading";
import GRSConferenceHeader from "../components/header/grs-header";
import EUCRMConferenceLayoutStyleComponent from "./components/eucrm-layout-style.component";

const GRSConferenceLayout = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(retrieveNotification())
  })
  return (
    <>
      <EUCRMConferenceLayoutStyleComponent />
      <div>
        <GRSConferenceHeader />
        <Suspense fallback={<LoadingComp />}>
          <Routes>
            {GRSConference.map((route, index) => {
              return route.component ? <Route key={index} path={route.path} element={route.component} /> : null;
            })}
          </Routes>
        </Suspense>
        <Footer />
        {/*<Convergence2023Footer footerClass="bg-primary text-light" />
        <SvgIcons />*/}
      </div >
    </>
  );
};

export default GRSConferenceLayout;